/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StatsOperationRecentIncidentActivityDto = {
    date: number;
    incidentName: string;
    issueNo: number;
    type?: StatsOperationRecentIncidentActivityDto.type;
};

export namespace StatsOperationRecentIncidentActivityDto {

    export enum type {
        COMMENT = 'COMMENT',
        STATUS_CHANGE = 'STATUS_CHANGE',
        USER_ASSIGNEES_CHANGE = 'USER_ASSIGNEES_CHANGE',
        TEAM_ASSIGNEES_CHANGE = 'TEAM_ASSIGNEES_CHANGE',
    }


}
